import { useEffect, useState } from 'react';
import { BROWSERS, Browser } from './addon-browsers';

const parseRating = (payload: unknown) => {
  const value = (payload as { value?: unknown } | null)?.value;

  if (typeof value !== 'string') {
    return undefined;
  }

  const rating = Number(value.split('/')[0]);

  return Number.isFinite(rating) ? rating : undefined;
};

export const useAddonRating = (browser: Browser) => {
  const [rating, setRating] = useState<number>();

  useEffect(() => {
    const controller = new AbortController();

    fetch(BROWSERS[browser].ratingUrl, { signal: controller.signal })
      .then((res) => (res.ok ? res.json() : null))
      .then((payload) => setRating(parseRating(payload)))
      .catch(() => {});

    return () => controller.abort();
  }, [browser]);

  return rating;
};
